import * as XLSX from 'xlsx';

export const generateXLSXReport = (data, filename = null) => {
  const workbook = XLSX.utils.book_new();

  if (data.sheets && Array.isArray(data.sheets)) {
    data.sheets.forEach((sheetObj) => {
      const ws = XLSX.utils.aoa_to_sheet(sheetObj.data || []);
      XLSX.utils.book_append_sheet(workbook, ws, sheetObj.name || "Sheet");
    });
  } else {
    const investmentSheet = XLSX.utils.aoa_to_sheet(data.investmentSheetData || []);
    const entriesSheet = XLSX.utils.aoa_to_sheet(data.allEntriesData || []);

    XLSX.utils.book_append_sheet(workbook, investmentSheet, data.investmentSheetName || "Investments");
    XLSX.utils.book_append_sheet(workbook, entriesSheet, data.entriesSheetName || "Collections");
  }

  const outputName = filename || `Finaculator_Report_${new Date().toLocaleDateString('en-IN').replace(/\//g, '-')}.xlsx`;
  XLSX.writeFile(workbook, outputName);
};



